<template>
  <div class="service-wrapper" id="service-wrapper">
    <div class="section">
      <div class="left">
        <div
          v-for="(item, index) in leftMenu"
          :key="item.key"
          :class="['item', { active: activeMenuIndex === index }]"
          @mousemove="handleMenuHover(index)"
          @click="handleMenuClick(item, index)"
        >
          <div class="title">
            <span class="text1">{{ $t(item.text1Key) }}</span>
            <span class="text2">{{ $t(item.text2Key) }}</span>
          </div>
          <div class="desc">{{ $t(item.descKey) }}</div>
          <img class="index-arr" src="@/static/image/index-arr.png" alt="arr" />
          <div class="border"></div>
        </div>
      </div>

      <div class="right">
        <div
          v-for="(group, groupIndex) in rightGroups"
          :key="group.key"
          :class="['top', `top${groupIndex}`, { hlw: groupIndex === 3 }]"
          v-show="activeMenuIndex === groupIndex"
        >
          <a
            v-for="(card, cardIndex) in group.cards"
            :key="card.titleKey"
            class="item"
            :class="[groupIndex === 3 ? 'left' : cardIndex < 2 ? 'left' : 'bot']"
            :target="card.link ? '_blank' : '_self'"
            :href="resolvedCardLink(card, groupIndex)"
            @mousemove="handleCardHover(groupIndex, cardIndex)"
          >
            <img :class="{ 'bot-img': groupIndex !== 3 && cardIndex === 2 }" :src="card.img" :alt="$t(card.titleKey)" />
            <div :class="['cover', { active: isCardActive(groupIndex, cardIndex) }]">
              <div class="title">
                <div class="text">
                  {{ $t(card.titleKey) }}
                  <img class="index-arr" src="@/static/image/index-arr.png" alt="arr" />
                </div>
                <div class="desc">{{ $t(card.descKey) }}</div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { resolveLocaleLink } from '@/utils/localeLink'

export default {
  name: 'ServiceSection',
  data() {
    return {
      activeMenuIndex: 0,
      activeCardIndexMap: {
        0: 0,
        1: 0,
        2: 0,
        3: 0
      },
      leftMenu: [
        {
          key: 'menu-1',
          text1Key: 'serviceSection.menu1Text1',
          text2Key: 'serviceSection.menu1Text2',
          descKey: 'serviceSection.menu1Desc',
          tabKey: 'labor'
        },
        {
          key: 'menu-2',
          text1Key: 'serviceSection.menu2Text1',
          text2Key: 'serviceSection.menu2Text2',
          descKey: 'serviceSection.menu2Desc',
          tabKey: 'talent'
        },
        {
          key: 'menu-3',
          text1Key: 'serviceSection.menu3Text1',
          text2Key: 'serviceSection.menu3Text2',
          descKey: 'serviceSection.menu3Desc',
          tabKey: 'manage'
        }
      ],
      rightGroups: [
        {
          key: 'group-0',
          cards: [
            {
              titleKey: 'serviceSection.g0c0Title',
              descKey: 'serviceSection.g0c0Desc',
              link: '/productService/lab.html#lwwb',
              img: require('@/static/image/index-ld1.png'),
              localizedLink: 'https://www.xchr-group.com/productService/lab.html#lwwb'
            },
            {
              titleKey: 'serviceSection.g0c1Title',
              descKey: 'serviceSection.g0c1Desc',
              link: '/productService/lab.html#lwpq',
              img: require('@/static/image/index-ld2.png'),
              localizedLink: 'https://www.xchr-group.com/productService/lab.html#lwpq'
            },
            {
              titleKey: 'serviceSection.g0c2Title',
              descKey: 'serviceSection.g0c2Desc',
              link: '/productService/lab.html#lhyg',
              img: require('@/static/image/index-ld3.png'),
              localizedLink: 'https://www.xchr-group.com/productService/lab.html#lhyg'
            }
          ]
        },
        {
          key: 'group-1',
          cards: [
            {
              titleKey: 'serviceSection.g1c0Title',
              descKey: 'serviceSection.g1c0Desc',
              link: '/productService/talent.html#rczp',
              img: require('@/static/image/index-rcfw1.png'),
              localizedLink: 'https://www.xchr-group.com/productService/talent.html#rczp'
            },
            {
              titleKey: 'serviceSection.g1c1Title',
              descKey: 'serviceSection.g1c1Desc',
              link: '/productService/talent.html#rccp',
              img: require('@/static/image/index-rcfw2.png'),
              localizedLink: 'https://www.xchr-group.com/productService/talent.html#rccp'
            },
            {
              titleKey: 'serviceSection.g1c2Title',
              descKey: 'serviceSection.g1c2Desc',
              link: '/productService/talent.html#rcpy',
              img: require('@/static/image/index-rcfw3.png'),
              localizedLink: 'https://www.xchr-group.com/productService/talent.html#rcpy'
            }
          ]
        },
        {
          key: 'group-2',
          cards: [
            {
              titleKey: 'serviceSection.g2c0Title',
              descKey: 'serviceSection.g2c0Desc',
              link: '/productService/manage.html#rlzy',
              img: require('@/static/image/index_glzx1.png'),
              localizedLink: 'https://www.xchr-group.com/productService/manage.html#rlzy'
            },
            {
              titleKey: 'serviceSection.g2c1Title',
              descKey: 'serviceSection.g2c1Desc',
              link: '/productService/manage.html#zlgh',
              img: require('@/static/image/index_glzx2.png'),
              localizedLink: 'https://www.xchr-group.com/productService/manage.html#zlgh'
            },
            {
              titleKey: 'serviceSection.g2c2Title',
              descKey: 'serviceSection.g2c2Desc',
              link: '/productService/manage.html#jth',
              img: require('@/static/image/index_glzx3.png'),
              localizedLink: 'https://www.xchr-group.com/productService/manage.html#jth'
            }
          ]
        },
        {
          key: 'group-3',
          cards: [
            {
              titleKey: 'serviceSection.g3c0Title',
              descKey: 'serviceSection.g3c0Desc',
              link: '/productService/internet.html',
              img: require('@/static/image/index-hlw.png'),
              localizedLink: 'https://www.xchr-group.com/productService/internet.html'
            }
          ]
        }
      ]
    }
  },
  methods: {
    handleMenuHover(index) {
      this.activeMenuIndex = index
    },
    handleCardHover(groupIndex, cardIndex) {
      this.$set(this.activeCardIndexMap, groupIndex, cardIndex)
    },
    handleMenuClick(item, index) {
      if (!item || !item.tabKey) return
      this.activeMenuIndex = index

      const locale = (this.$i18n && this.$i18n.locale) || 'zh-CN'
      if (locale === 'zh-CN') return

      this.$router.push({
        path: '/home/labor-relations',
        query: { tab: item.tabKey, lang: locale }
      })
    },
    isCardActive(groupIndex, cardIndex) {
      return this.activeCardIndexMap[groupIndex] === cardIndex
    },
    resolvedCardLink(card, groupIndex) {
      if (!card || !card.link) return 'javascript:void(0)'

      const locale = (this.$i18n && this.$i18n.locale) || 'zh-CN'
      if (locale !== 'zh-CN') {
        const tabMap = ['labor', 'talent', 'manage', 'labor']
        const tab = tabMap[groupIndex] || 'labor'
        return `/home/labor-relations?tab=${tab}&lang=${locale}`
      }

      return resolveLocaleLink(locale, card.link)
    }
  }
}
</script>

<style scoped lang="scss">
.service-wrapper {
  background: url('~@/static/image/index-service.png') no-repeat center center;
  width: 100%;
  height: 680px;
  background-size: cover;

  .section {
    width: 1200px;
    height: 680px;
    margin: 0 auto;
  }

  .left {
    width: 460px;
    height: 680px;
    float: left;

    .item {
      cursor: pointer;
      color: #ffffff;
      padding-bottom: 25px;
      padding-left: 37px;
      position: relative;
      margin-top: 66px;
      text-align: left;

      .title {
        opacity: 0.7;
        .text1 {
          font-size: 18px;
          font-weight: 600;
        }

        .text2 {
          font-size: 24px;
        }
      }

      .desc {
        margin-top: 6px;
        font-size: 16px;
        opacity: 0.7;
      }

      .index-arr {
        position: absolute;
        width: 0;
        height: 13px;
        left: 37px;
        bottom: 0;
        opacity: 0.7;
        transition: all 0.2s linear;
        color: #fff;
        font-size: 28px;
        line-height: 13px;
        overflow: hidden;
        white-space: nowrap;
      }

      .border {
        width: 6px;
        height: 0;
        background-color: #5b9fff;
        position: absolute;
        top: 0;
        left: 0;
        transition: all 0.2s linear;
      }

      &.active {
        .title {
          opacity: 1;
        }

        .border {
          height: 75px;
        }

        .index-arr {
          width: 47px;
        }
      }
    }
  }

  .right {
    width: 740px;
    height: 680px;
    float: right;

    .top {
      cursor: pointer;
      height: 680px;

      .left {
        width: 370px;
        height: 340px;
        float: left;
        position: relative;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      &.hlw {
        width: 100%;
        height: 100%;

        .left {
          width: 740px;
          height: 680px;
        }
      }
    }

    .bot {
      cursor: pointer;
      position: relative;
      height: 340px;
      top: 340px;
      display: block;

      .bot-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 340px;
        object-fit: cover;
      }
    }

    .cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      text-align: left;
      .title {
        font-size: 20px;
        position: absolute;
        left: 0;
        width: 100%;
        bottom: 24px;
        font-weight: 600;
        .text {
          position: relative;
          padding: 0 28px;
          color: #ffffff;
          font-size: 18px;
          line-height: 1.2;
        }

        .index-arr {
          width: 0;
          height: 10px;
          position: absolute;
          right: 26px;
          top: 50%;
          margin-top: -5px;
          opacity: 0.7;
          transition: all 0.2s linear;
          overflow: hidden;
          white-space: nowrap;
          font-size: 24px;
          line-height: 10px;
        }
      }

      .desc {
        color: #ffffff;
        font-size: 14px;
        line-height: 20px;
        opacity: 0.7;
        margin-top: 8px;
        padding: 0 24px;
        display: none;
      }

      &.active {
        background: linear-gradient(180deg, rgba(238, 238, 238, 0) 0%, rgba(0, 0, 0, 0.44) 44%, #000000 100%);

        .desc {
          display: block;
        }

        .index-arr {
          width: 30px;
        }
      }
    }
  }
}
</style>
